import React from 'react'
import DetailedBudgetCost from './detailedList'

const AwsDetailedBudgetCost = ({service}) => {
  return (
   <DetailedBudgetCost service ={service}/>
  )
}

export default AwsDetailedBudgetCost